module.exports = __webpack_public_path__ + "static/media/pet-partners.04bd186b.svg";